import React from 'react';

import { isFedRamp } from '@atlassian/atl-context';

import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs';
import { SPACE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE } from '@confluence/confluence-analytics/entry-points/analyticsConstants';
import {
	FEDRAMP_SPACE_ANALYTICS_PERMISSIONS_PLUGIN,
	SPACE_ANALYTICS_PERMISSIONS_PLUGIN,
	SPACE_PERMISSIONS_SETTINGS,
} from '@confluence/named-routes';
import type { RouteMatch } from '@confluence/route';
import { Redirection } from '@confluence/route-manager';
import { fg } from '@confluence/feature-gating';

// TODO - CCIR-11: Remove this entire route and replace with SPACE_PERMISSIONS_SETTINGS once the
// Analytics native UI migration is complete

export const SpaceAnalyticsPermissionsRoute = ({ params: { spaceKey }, search }: RouteMatch) => {
	if (fg('confluence_frontend_analytics_permissions')) {
		return (
			<Redirection
				href={`${SPACE_PERMISSIONS_SETTINGS.toUrl({ spaceKey, tab: 'analytics' })}${search}`}
			/>
		);
	}

	const url = isFedRamp()
		? FEDRAMP_SPACE_ANALYTICS_PERMISSIONS_PLUGIN.toUrl({ spaceKey })
		: SPACE_ANALYTICS_PERMISSIONS_PLUGIN.toUrl({ spaceKey });
	return <Redirection href={`${url}${search}`} />;
};

SpaceAnalyticsPermissionsRoute.NAVIGATION_PARAMS = (
	{ name, params: { spaceKey } }: RouteMatch,
	isNav4Enabled: boolean,
) => ({
	Screen: {
		screenEvent: { name: SPACE_ANALYTICS_PERMISSIONS_EVENTS_SOURCE, id: spaceKey },
		pageState: { routeName: name, spaceKey },
	},
	MainLayout: {
		spaceKey,
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
	},
});
